module.exports = __webpack_public_path__ + "static/features-phone-languages-d31d9ae99d85ada64b08245e0b2c11f2.png";